import { Controller } from "stimulus";
import {withTogglesOutsideClick} from "mixins/withTogglesOutsideClick";
import {withPopUp, withPopUpTargets} from "mixins/withPopUp";

export default class extends withPopUp(withTogglesOutsideClick(Controller)) {
    static targets = withPopUpTargets

    closeToggle() {
        super.closeToggle();
        this.closeDropDown();
    }

    openToggle() {
        super.openToggle();
        this.openDropDown();
    }
    onOutsideClick(event) {
        if (!this.element.contains(event.target) && !this.getDropDownTarget().contains(event.target)) {
            this.closeToggle();
            this.closeDropDown();
        }
    }
}
